/* Oshun cart sync (R85a). Keeps the $120 service line equal to
   expected = sum(qty) over lines with Studio Logo = Printed Upholstery.
   0 expected removes it, so an orphan added by URL is cleaned up too. */
(function () {
  'use strict';
  var VARIANT = 48267237818526;
  var HANDLE = 'printed-logo-carriage-upholstery';
  var PROP = 'Studio Logo', VAL = 'Printed Upholstery';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;   // guards re-entry; our own calls are skipped
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) });
  }
  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function expected(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (String(p[PROP] == null ? '' : p[PROP]) === VAL) { n += it.quantity; }
    });
    return n;
  }
  function svcLines(cart) {
    var out = [];
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === VARIANT) { out.push({ key: it.key, qty: it.quantity }); }
    });
    return out;
  }
  function notify(cart) {
    /* cart:refresh only. The theme's cart:change handler expects a Section Rendering payload and
       throws on a bare /cart.js body; cart:refresh makes it re-fetch and re-render by itself. */
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    tidy();
  }
  /* service line is per-reformer, not independently editable */
  function tidy() {
    try {
      var links = document.querySelectorAll('a[href*="' + HANDLE + '"]');
      for (var i = 0; i < links.length; i++) {
        var row = links[i].closest('.hdt-mini-cart__item, .hdt-cart-item, li, tr');
        if (!row) { continue; }
        var q = row.querySelector('hdt-quantity-wrapp, [data-quantity-wrapper]');
        var r = row.querySelector('wrapp-remove-item-oncart, .hdt-mini-cart__remove');
        if (q) { q.style.display = 'none'; }
        if (r) { r.style.display = 'none'; }
      }
    } catch (e) {}
  }
  function reconcile() {
    if (busy) { return Promise.resolve({ changed: false, reason: 'busy' }); }
    busy = true;
    return getCart().then(function (cart) {
      var want = expected(cart), svc = svcLines(cart), ops = [];
      if (svc.length > 1) {            // collapse to one
        for (var i = 1; i < svc.length; i++) { ops.push({ key: svc[i].key, qty: 0 }); }
        if (svc[0].qty !== want) { ops.push({ key: svc[0].key, qty: want }); }
      } else if (svc.length === 1) {
        if (svc[0].qty !== want) { ops.push({ key: svc[0].key, qty: want }); }
      } else if (want > 0) {
        ops.push({ add: true, qty: want });
      }
      if (!ops.length) { busy = false; tidy(); return { changed: false }; }
      var chain = Promise.resolve();
      ops.forEach(function (op) {
        chain = chain.then(function () {
          return op.add
            ? post('cart/add.js', { items: [{ id: VARIANT, quantity: op.qty, properties: { '_For': VAL } }] })
            : post('cart/change.js', { id: op.key, quantity: op.qty });
        });
      });
      return chain.then(getCart).then(function (fresh) {
        busy = false; notify(fresh); return { changed: true, ops: ops.length };
      });
    }).catch(function () { busy = false; return { changed: false, error: true }; });
  }
  function later() { if (!busy) { window.setTimeout(reconcile, 80); } }
  var CART_RE = /\/cart\/(add|change|update|clear)/;
  /* call through, then reconcile on completion */
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (CART_RE.test(url) && !busy) { p.then(later, function () {}); }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    try {
      if (CART_RE.test(String(url || ''))) {
        this.addEventListener('loadend', function () { later(); });
      }
    } catch (e) {}
    return _open.apply(this, arguments);
  };
  /* Checkout: reconcile on pointerdown, which lands before the click, and never block or
     re-dispatch the event. This theme drives checkout from its own handler on the button, so
     intercepting the click stops the shopper reaching checkout at all - a far worse failure than
     a briefly stale service line. Every cart mutation and every page load already reconciles. */
  ['pointerdown', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (ev) {
      var t = ev.target && ev.target.closest ? ev.target.closest('[name="checkout"], a[href*="/checkout"]') : null;
      if (t) { reconcile(); }
    }, true);
  });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', reconcile); } else { reconcile(); }
  try { new MutationObserver(tidy).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  window.OshunCartSync = { reconcile: reconcile };
})();
